import moment from 'moment';
//
import { IDeal, ESearchFilter } from 'store/deals/types';
import { removeUserGroup } from 'lib/helpers/name-formatters';
import { isMatch } from 'store/formula-entry/match';

const checkEmployeeNameSearchKeywordFilter = (
  searchKeyword: string,
  employeeName: string | null,
  searchFilter: ESearchFilter
) => {
  return !searchKeyword || !employeeName || !searchFilter;
};

// Takes a deal array and filters them using the keyword and
// then returns the array of relevant deals
export function filterDealsBySearchKeyword(
  employeeName: string | null,
  deals: IDeal[],
  fields: string[],
  searchFilter: ESearchFilter,
  searchKeyword: string,
  statusFilter = 'all'
): IDeal[] {
  // Filter deals by user
  const userOwnedDeals: IDeal[] =
    searchFilter === ESearchFilter.ALL
      ? deals
      : deals.filter(deal => {
          const { createdBy } = deal;
          return createdBy && removeUserGroup(createdBy).toLowerCase() === employeeName;
        });

  const statusDeals: IDeal[] =
    statusFilter === 'all'
      ? userOwnedDeals
      : userOwnedDeals.filter(deal => {
          return deal.status === statusFilter;
        });

  // No keyword -- return everything
  if (checkEmployeeNameSearchKeywordFilter(searchKeyword, employeeName, searchFilter) || !fields || !statusDeals) {
    return statusDeals;
  }

  // Combine all field strings into one that can be searched using
  // searchKeyword match function
  const filteredDeals: IDeal[] = statusDeals.filter(deal => {
    const fieldsCombined = fields
      .map(field => {
        // Convert ISO date from API to user-friendly string for searching
        if (field === 'createdOn' || field === 'modifiedOn') {
          return moment(deal[field]).format('MM/DD/YYYY');
        }
        return deal[field];
      })
      .join(' ');
    return isMatch(searchKeyword, fieldsCombined);
  });

  return filteredDeals;
}
